export default __webpack_public_path__ + "static/media/sketch10.55db91d9.png";